import { ElementType } from "react";
import CCCollectionPointSidebarIcon from "../assets/icons/CCCollectionPointSidebarIcon";
import CCFieldOfficerSidebarIcon from "../assets/icons/CCFieldOfficerSidebarIcon";
import CCTerritoryManageSidebarIcon from "../assets/icons/CCTerritoryManageSidebarIcon";
import HomeIcon from "../assets/icons/HomeIcon";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import WalletIcon from "../assets/icons/WalletIcon";
import { Role } from "../types/common";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const CashCollectionSidebarMenu: MenuTypes[] = [
  {
    name: "Sheba Portal",
    path: "/admin/dashboard",
    icon: HomeIcon,
    role: [],
  },
  {
    name: "Dashboard",
    path: "/admin/cash-dashboard",
    icon: DashboardIcon,
    role: ["CASH_USER"],
  },
  {
    name: "FO Transaction",
    path: "/admin/cash-transactions",
    icon: WalletIcon,
    role: ["CASH_USER"],
  },
  {
    name: "Bank Transactions",
    path: "/admin/bank-transactions",
    icon: WalletIcon,
    role: ["CASH_USER"],
  },
  {
    name: "Collection Points",
    path: "/admin/cash-collection-point",
    icon: CCCollectionPointSidebarIcon,
    role: ["CASH_USER"],
  },
  {
    name: "Field Officers",
    path: "/admin/cash-field-officers",
    icon: CCFieldOfficerSidebarIcon,
    role: ["CASH_USER"],
  },
  {
    name: "Territory Management",
    path: "/admin/cash-territory-management",
    icon: CCTerritoryManageSidebarIcon,
    role: ["CASH_USER"],
    children: [
      {
        name: "Zone",
        path: "/admin/cash-territory-management/zone",
        role: ["CASH_USER"],
      },
      {
        name: "Area",
        path: "/admin/cash-territory-management/area",
        role: ["CASH_USER"],
      },
      {
        name: "Territory",
        path: "/admin/cash-territory-management/territory",
        role: ["CASH_USER"],
      },
      {
        name: "Route",
        path: "/admin/cash-territory-management/route",
        role: ["CASH_USER"],
      },
    ],
  },
];

export default CashCollectionSidebarMenu;
